import React from 'react'
import { Box, Container, Paper, Text, Title } from '@mantine/core'
import { useStore } from '../../app/stores/store'

export default function ServerError () {
  const { commonStore } = useStore()
  return (
    <Container size="md" py="xl">
      <Title order={1} mb="sm">Server Error</Title>
      <Text color="red" size="lg" mb="lg">
        {commonStore.error?.message}
      </Text>
      {commonStore.error?.details && (
        <Paper p="lg" withBorder>
          <Title order={4} mb="md">Stack trace</Title>
          <Box component="pre" sx={{ overflow: 'auto', fontSize: 12, margin: 0 }}>
            <code>{commonStore.error.details}</code>
          </Box>
        </Paper>
      )}
    </Container>
  )
}
